var map = {
	"./Pages/Display": 6684,
	"./Pages/Display.js": 6684,
	"./React/Book": 8312,
	"./React/Book.js": 8312,
	"./React/Day": 8192,
	"./React/Day.js": 8192,
	"./React/Details": 2552,
	"./React/Details.js": 2552,
	"./React/Highlights": 836,
	"./React/Highlights.js": 836,
	"./React/Intro": 7504,
	"./React/Intro.js": 7504,
	"./React/Main": 3700,
	"./React/Main.js": 3700,
	"./React/Summary": 9794,
	"./React/Summary.js": 9794,
	"./React/Thanks": 3832,
	"./React/Thanks.js": 3832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3148;